// extracted by mini-css-extract-plugin
export default {"root":"Search_root__eiX89","input":"Search_input__klILD","searchIcon":"Search_searchIcon__Y3CpY","closeIcon":"Search_closeIcon__NXfUo"};